import { formatNumber } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { PlanningMaterial } from '../classes/planning-material.class';
import { RawMaterial } from '../classes/raw-material.class';

const CONSUMPTION_TYPE_KG_M2 = 'kg/m2';
const CONSUMPTION_TYPE_PERCENTAGE = "% van kg's";
const CONSUMPTION_TYPE_LTR_M1 = 'ltr/m1';

@Pipe({
    name: 'rawMaterialQuantity',
    standalone: false,
})
export class RawMaterialQuantityPipe implements PipeTransform {
    transform(rawMaterial: RawMaterial | null, planningMaterial: PlanningMaterial | null): string {
        if (!rawMaterial || !planningMaterial) {
            return '';
        }

        const quantity = planningMaterial.quantity;
        const material = planningMaterial.material;
        const mainRawMaterial = material?.raw_materials?.find(rm => rm.material_type?.main);
        const consumptionTypeName = rawMaterial.consumption_type?.name;

        if (!consumptionTypeName || rawMaterial.consumption == null) {
            return '';
        }

        let result: number | null = null;
        let unit = '';

        if (consumptionTypeName === CONSUMPTION_TYPE_PERCENTAGE) {
            result = (rawMaterial.consumption / 100) * quantity;
            unit = 'kg';
        } else if (consumptionTypeName === CONSUMPTION_TYPE_KG_M2) {
            if (!mainRawMaterial?.consumption) {
                return '';
            }
            const m2 = quantity / mainRawMaterial.consumption;
            result = rawMaterial.consumption * m2;
            unit = 'kg';
        } else if (consumptionTypeName === CONSUMPTION_TYPE_LTR_M1) {
            if (mainRawMaterial?.consumption) {
                const m1 = quantity / mainRawMaterial.consumption;
                result = rawMaterial.consumption * m1;
            } else if (mainRawMaterial?.width) {
                result = rawMaterial.consumption * quantity;
            }
            unit = 'ltr';
        }

        return result ? `${formatNumber(result, 'nl', '0.0-3')} ${unit}` : '';
    }
}
